import { Component, Injector, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CrudComAbasComponent, Widget } from 'src/app/@layout/template-padrao/crud-com-abas/crud-com-abas.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CorrecoesErrosCteService } from 'src/app/services/correcoes-erros-cte/correcoes-erros-cte.service';
import { AcompanhamentoCorrecoesErrosCteFiltrosPesquisaComponent } from './acompanhamento-correcoes-erros-cte-filtros-pesquisa/acompanhamento-correcoes-erros-cte-filtros-pesquisa';
import { AcompanhamentoCorrecoesErrosCteGridPesquisaComponent } from './acompanhamento-correcoes-erros-cte-grid-pesquisa/acompanhamento-correcoes-erros-cte-grid-pesquisa';
import { CorrecoesErrosCteModel } from './acompanhamento-correcoes-erros-cte.model';
import { MatTabGroup } from '@angular/material/tabs';
import { ViewChild } from '@angular/core';
@Component({
  selector: 'app-acompanhamento-correcoes-erros-cte',
  templateUrl: "../../../@layout/template-padrao/crud-com-abas/crud-com-abas.component.html",
  styleUrls: ["../../../@layout/template-padrao/crud-com-abas/crud-com-abas.component.scss"],
})
export class AcompanhamentoCorrecoesErrosCteComponent extends CrudComAbasComponent<CorrecoesErrosCteModel>
  implements OnInit {
  @Input() override featureId: string;
  public habilitarEditacao: boolean = false;
  public habilitarInclusao: boolean = false;
  public componenteFiltro: Widget;
  public componenteGrid: Widget;
  override exibeBotaoNovo = false;

  alterar() { }
  novo() { }

  public titulo: string = "Acompanhamento de lotes CT-e";
  public subtitulo: string = "";

  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  formPesquisa = new FormGroup({
    dataInicio: new FormControl(''),
    dataFim: new FormControl(''),
    clienteId: new FormControl(''),
    numeroLote: new FormControl(''),
    numeroCte: new FormControl(''),
    chaveCte: new FormControl(''),
    codBarras: new FormControl(''),
    usuario: new FormControl(''),
    statusLote: new FormControl(''),
    acoes: new FormControl(''),
  });

  constructor(
    public override injectorObj: Injector,
    public authService: AuthService,
    public override service: CorrecoesErrosCteService
  ) {
    super(injectorObj, service);
    this.setFilterComponent(AcompanhamentoCorrecoesErrosCteFiltrosPesquisaComponent);
    this.setGridComponent(AcompanhamentoCorrecoesErrosCteGridPesquisaComponent);
  }

  override ngOnInit() {
  }

}
